/* PF 12.10.2026 - Spedizione assicurata nel cart drawer (CR 123ztrd03xk) */
(() => {
  if (window.pfCartInsurance) return;
  window.pfCartInsurance = true;

  const postJson = (url, body) => fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body)
  }).then((res) => res.json());

  const refreshDrawer = () => document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));

  const getInsurance = () => document.querySelector('.pf-insurance');

  // Imposta la riga assicurazione a 0 o 1 pezzo
  async function setInsurance(enabled) {
    const box = getInsurance();
    if (!box) return;
    const productId = Number(box.dataset.productId);
    const cart = await fetch(`${theme.routes.cart || '/cart'}.js`).then((res) => res.json());
    const line = cart.items.find((item) => item.product_id === productId);

    if (enabled && !line) {
      await postJson(`${theme.routes.cartAdd}.js`, { items: [{ id: Number(box.dataset.variantId), quantity: 1 }] });
    } else if (enabled && line.quantity !== 1) {
      await postJson(`${theme.routes.cartChange}.js`, { id: line.key, quantity: 1 });
    } else if (!enabled && line) {
      await postJson(`${theme.routes.cartChange}.js`, { id: line.key, quantity: 0 });
    }
  }

  // Se nel carrello resta solo l'assicurazione, la toglie
  async function removeIfAlone() {
    const box = getInsurance();
    if (!box) return;
    const productId = Number(box.dataset.productId);
    const cart = await fetch(`${theme.routes.cart || '/cart'}.js`).then((res) => res.json());
    const line = cart.items.find((item) => item.product_id === productId);
    if (line && cart.items.length === 1) {
      await postJson(`${theme.routes.cartChange}.js`, { id: line.key, quantity: 0 });
      // rerender completo, così il drawer mostra lo stato di carrello vuoto
      const drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.refresh) drawer.refresh(true);
      else refreshDrawer();
    }
  }

  document.addEventListener('change', async (evt) => {
    if (!evt.target.classList.contains('js-pf-insurance')) return;
    const input = evt.target;
    const box = input.closest('.pf-insurance');
    input.disabled = true;
    box.classList.add('is-loading');
    try {
      await setInsurance(input.checked);
    } catch (error) {
      input.checked = !input.checked;
      console.log(error); // eslint-disable-line
    }
    refreshDrawer();
  });

  // Il tema conta solo le righe visibili, quindi on:line-item:change non scatta quando
  // resta solo l'assicurazione: si controlla a ogni rerender delle righe del drawer
  let pending;
  const checkDrawer = () => {
    clearTimeout(pending);
    pending = setTimeout(() => {
      const items = document.querySelector('cart-drawer cart-items');
      if (items && items.dataset.empty === 'false' && !items.querySelector('.cart-item')) removeIfAlone();
    }, 300);
  };
  const drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(checkDrawer).observe(drawer, { childList: true, subtree: true });
  document.addEventListener('on:cart-drawer:before-open', checkDrawer);
})();
